import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useInvitationRemoveMutation } from "@/v2-backoffice-client/invitation/remove/invitation.remove.mutation"

export type InvitationRemoveButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  invitationId: number
  confirmDescription?: string
  onCompleted?(): void
}

function InvitationRemoveButton(props: InvitationRemoveButtonProps) {
  const { invitationId, confirmDescription, onCompleted, ...rest } = props

  const [removeInvitation, { loading, error }] = useInvitationRemoveMutation({
    onCompleted,
  })

  errorToast(error, {
    title: "Failed to remove invitation",
  })

  return (
    <ConfirmButton
      id="invitation-remove-button"
      variant="destructive"
      size="tiny"
      iconSrc="trash"
      content="Remove invitation"
      confirmContent={
        confirmDescription ?? "Are you sure you want to remove this invitation?"
      }
      isLoading={loading}
      onConfirm={() => {
        removeInvitation({ variables: { id: invitationId } })
      }}
      {...rest}
    />
  )
}

export default InvitationRemoveButton
